import { Component, OnInit} from '@angular/core';
import { environment } from '@environments/environment';
import { RouterOutlet } from '@angular/router';
import { DevComponent } from './core/components/dev/dev.component';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, DevComponent]
})
export class AppComponent implements OnInit {
  isProd: boolean;
  constructor() {


    
  }

  ngOnInit(): void {
    this.isProd = environment.production;
    console.log(environment.production);
   // this.request();

  }

  request() {
   // Notification.requestPermission();
  }




}
